import { css } from 'lit';
import componentStyles from '../../styles/component.styles.js';
export default css `
    ${componentStyles}

    .user-menu {
        display: flex;
        align-items: center;
        cursor: pointer;
    }

    .avatar {
        margin-right: var(--sgdf-spacing-small);
    }

    .user-detail {
        display: flex;
        flex-direction: column;
        font-family: var(--sgdf-input-font-family);
        text-transform: uppercase;
        /* color: var(--sgdf-color-default); */
        margin-right: var(--sgdf-spacing-2x-small);
    }

    .username {
        font-weight: var(--sgdf-font-weight-semibold);
    }

    .role {
        font-size: var(--sgdf-font-size-small);
    }

    .user-menu__menu {
        max-height: 50vh;
        overflow: auto;
    }
`;
//# sourceMappingURL=UserMenu.styles.js.map